import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import {
  thirdPartyLeakage,
  thirdPartyLeakageSlides,
} from "@/constants/thirdPartyLeakage";

const ThirdPartyLeakage: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={thirdPartyLeakageSlides}
      quizName={SecurityTopicEnum.ThirdPartyLeakage}
      quizList={thirdPartyLeakage}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default ThirdPartyLeakage;
